
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import SingleRankingDisplay from '@/components/streaming-charts/SingleRankingDisplay.vue';

import {
	GetTitleRankingDocument,
	GetTitleRankingQueryVariables,
} from '@/components/graphql/queries/GetTitleRanking.query';
import { ObjectType, PopularityRankTypes, StreamingChartInfo } from '@/@types/graphql-types';

@Component({
	name: 'TitleRankingList',
	components: { SingleRankingDisplay },
	apollo: {
		titleRankingData: {
			query: GetTitleRankingDocument,
			variables(): GetTitleRankingQueryVariables {
				return {
					country: this.country,
					filter: {
						jwEntityID: this.titleId,
						category: PopularityRankTypes.DailyPopularitySameContentType,
						previousTitles: 0,
						nextTitles: 0,
						objectType: this.objectType,
					},
				};
			},
			update(data) {
				return data?.streamingCharts?.edges?.[0]?.streamingChartInfo;
			},
		},
	},
})
export default class TitleRankingList extends Vue {
	titleRankingData: StreamingChartInfo = {} as StreamingChartInfo;

	@Prop({ required: true }) titleId: string;
	@Prop({ required: true }) objectType: ObjectType;
	@Prop({ required: true }) country: string;
}
